export const getHandlers = (array, handler) => {
  return array.reduce((acc, cur) => {
    acc[cur] = { handleChange: handler }
    return acc
  }, {})
}
